import { Model, Attr, BelongsTo } from 'spraypaint'

import ApplicationRecord from '@/models/ApplicationRecord'
import { Budget, MultiChoiceCardOrder } from '@/models/index'

@Model()
export default class BudgetMove extends ApplicationRecord {
  static jsonapiType = 'budget_moves'

  @Attr() id!: string
  @Attr() createdAt!: string
  @Attr() amount!: number
  @Attr() creditedAt!: string
  @Attr() sourceType!: string
  @Attr() reserved!: boolean

  @BelongsTo() budget!: Budget
  @BelongsTo() source!: any
  @BelongsTo() multiChoiceCardOrder!: MultiChoiceCardOrder
}
